// Consent to send personal data to Google's Gemini API.
// CONSENT_VERSION is duplicated in convex/aiConsent.ts — the client and Convex
// bundles do not share modules. Bump both together, or the client will believe
// a grant is current while the server rejects it.
export const CONSENT_VERSION = 1;

export type AiConsent = {
  status: "granted" | "declined";
  version: number;
  updatedAt: number;
};

/** AI features may run only on a grant recorded at the current version. */
export function isAiEnabled(
  consent?: AiConsent | null,
  version: number = CONSENT_VERSION
): boolean {
  return consent?.status === "granted" && consent.version >= version;
}

/**
 * Show the consent sheet on native when there is no decision recorded at the
 * current version. A stale decision — granted or declined — is re-asked,
 * because a version bump means the disclosure copy materially changed.
 */
export function shouldPromptForConsent(
  consent: AiConsent | null | undefined,
  isNative: boolean,
  version: number = CONSENT_VERSION
): boolean {
  if (!isNative) return false;
  return !consent || consent.version < version;
}

/**
 * Client-side mirror of convex/aiConsent.ts `consentSatisfied`. The gate ships
 * on native only, so off native AI stays available exactly as it was before
 * consent existed. Keep these two in step: if the client is more permissive
 * than the server, users hit AI_CONSENT_REQUIRED errors with no way to consent.
 */
export function isAiAllowed(
  consent: AiConsent | null | undefined,
  isNative: boolean,
  version: number = CONSENT_VERSION
): boolean {
  if (!isNative) return true;
  return isAiEnabled(consent, version);
}
